const skCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Pomenujte váš súbor...",
    description: "Placeholder for file name input",
  },
};

export default skCreateFile;
